var _defs, _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stage_1:_First_Impression",
    "data-name": "Stage 1: First Impression",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 51.351,
    viewBox: "0 0 50 51.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1725",
    "data-name": "Rectangle 1725",
    width: 29.761,
    height: 36.294,
    fill: "#fff"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_680",
    "data-name": "Ellipse 680",
    cx: 25,
    cy: 25.676,
    rx: 25,
    ry: 25.676,
    fill: "#ee3d4b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32051",
    "data-name": "Group 32051",
    transform: "translate(12.196 7.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32050",
    "data-name": "Group 32050",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13518",
    "data-name": "Path 13518",
    d: "M16.432,12.245a1.987,1.987,0,0,0-1.96,1.96,1.96,1.96,0,1,0,1.96-1.96",
    transform: "translate(9.029 7.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13519",
    "data-name": "Path 13519",
    d: "M13.525,1.533a.991.991,0,1,1,1.4,1.4,1.989,1.989,0,0,0,0,2.8,3.976,3.976,0,0,1,0,5.611,1.041,1.041,0,0,1-.7.281.951.951,0,0,1-.7-.281.992.992,0,0,1,0-1.4,1.949,1.949,0,0,0,.049-2.756l-.049-.049a3.973,3.973,0,0,1,0-5.611M9.49.281a.992.992,0,0,1,1.4,1.4,1.989,1.989,0,0,0,0,2.8,4.021,4.021,0,0,1,0,5.645,1.041,1.041,0,0,1-.7.281.946.946,0,0,1-.7-.281,1,1,0,0,1,0-1.4,1.989,1.989,0,0,0,0-2.8,3.963,3.963,0,0,1-.042-5.6L9.49.281M25.506,26.088a4.237,4.237,0,0,1-2.244-.65,12.491,12.491,0,0,1-5.06,8.569h4.04a1.143,1.143,0,1,1,0,2.286H1.143a1.143,1.143,0,1,1,0-2.286H5.222A12.9,12.9,0,0,1,0,24.173v-8.98a1.136,1.136,0,0,1,1.137-1.137h21.1a1.136,1.136,0,0,1,1.137,1.137v2.85a4.486,4.486,0,0,1,2.079-.531,4.285,4.285,0,1,1,.042,8.569",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage1);
export default __webpack_public_path__ + "static/media/stage1.26d9059956c4bd3d79b390438e51eb65.svg";
export { ForwardRef as ReactComponent };